export default __webpack_public_path__ + "static/assets/5dc93f4372be3491c444bc746e2ffc5e.gif";